export type LoqateValidationFields = 'address' | 'email' | 'bank';

export type LoqateEmailSuccessResponse = 'Valid' | 'Valid_CatchAll';
export type LoqateEmailFailureResponse = 'Invalid';
export type LoqateEmailResponse = LoqateEmailSuccessResponse | LoqateEmailFailureResponse;

export const loqateEmailSuccessResponses: LoqateEmailResponse[] = [
    'Valid',
    'Valid_CatchAll',
];
export const loqateEmailFailureResponses: LoqateEmailResponse[] = ['Invalid'];

export interface LoqateEmailResponseItem {
    ResponseCode: LoqateEmailSuccessResponse | LoqateEmailFailureResponse;
    ResponseMessage: string;
    EmailAddress: string;
    UserAccount: string;
    Domain: string;
    IsDisposableOrTemporary: boolean;
    IsComplainerOrFraudRisk: boolean;
    Duration: number;
}

export interface LoqateBankResponseItem {
    OriginalAccountNumber: string;
    OriginalSortCode: string;
    IsCorrect: boolean;
    IsDirectDebitCapable: boolean;
    StatusInformation: string;
    CorrectedSortCode: string;
    CorrectedAccountNumber: string;
    IBAN: string;
    Bank: string;
    BankBIC: string;
    Branch: string;
    BranchBIC: string;
    ContactAddressLine1: string;
    ContactAddressLine2: string;
    ContactPostTown: string;
    ContactPostcode: string;
    ContactPhone: string;
    ContactFax: string;
}

export interface LoqateAddressFindResponseItem {
    Id: string;
    Type: string;
    Text: string;
    Highlight: string;
    Description: string;
}

export interface LoqateEmailResponseObject {
    Items: LoqateEmailResponseItem[];
}

export interface LoqateAddressFindResponseObject {
    Items: LoqateAddressFindResponseItem[];
}

export interface LoqateBankResponseObject {
    Items: LoqateBankResponseItem[];
}

export interface LoqateAddressRetrieveResponseObject {
    Items: LoqateAddressRetrieveResponseItem[];
}

export interface LoqateAddressRetrieveResponseItem {
    Id: string;
    Street: string;
    City: string;
    Line1: string;
    Line2: string;
    Line3: string;
    Line4: string;
    Province: string;
    PostalCode: string;
}
